<template>
    <div class="emarticonlist-wrap">
        <div class="emarticonlist-top">
          <select @change="$emit('getPrepaidCardGoods', orderCriteria)" v-model="orderCriteria" title="정렬 선택" required>
            <option selected v-for="item in orderConditionList" :value="item.orderCriteria">
              {{ item.orderName }}
            </option>
          </select>
        </div>
      <ul>
        <li class="emarticon-li" tabindex="0" v-for="goods in goodsList">
          <div class="emarticon-item">
            <div>
              <img class="item-image" :src="goods.thumbnailImageUrl" :alt="goods.thumbnailImageDesc"/>
            </div>
            <div class="item-text-box">
              <div>
                <strong>{{ goods.goodsName }}</strong>
<!--                <em class="item-subject">결제가<span>{{ Number(goods.goodsAmount).toLocaleString() }}</span></em>-->
<!--                <em v-if="goods.benefitAmount !== null && goods.benefitAmount > 0" class="item-subject">혜택가<span class="red">{{ Number(goods.benefitAmount).toLocaleString() }}</span></em>-->
              </div>
              <div class="item-info-box">
<!--                <span class="blue">시상용</span>-->
              </div>
            </div>
          </div>
          <div class="list-button-box">
<!--            <button @click="moveGoodsDetail(goods, 'BUY')">구매하기</button>-->
<!--            <button @click="moveGoodsDetail(goods, 'GIFT')">선물하기</button>-->
<!--            <button type="button" @click="moveGoodsDetail(goods, 'BUY')">구매하기-->
<!--              <div class="buy-badge" v-if="goods.conditionKey">-->
<!--                <span v-if="goods.conditionKey == 'FIXED_RATE_EXTRA_CHARGE' || goods.conditionKey == 'FIXED_RATE_DISCOUNT'">{{goods.conditionValue}}%</span>-->
<!--                <span v-else-if="goods.conditionKey == 'FLAT_EXTRA_CHARGE' || goods.conditionKey == 'FLAT_DISCOUNT'">{{goods.conditionValue | comma}}원</span>-->
<!--                <span v-if="goods.conditionKey == 'FIXED_RATE_EXTRA_CHARGE' || goods.conditionKey == 'FLAT_EXTRA_CHARGE'">추가</span>-->
<!--                <span v-else-if="goods.conditionKey == 'FIXED_RATE_DISCOUNT' || goods.conditionKey == 'FLAT_DISCOUNT'" >할인</span>-->
<!--              </div>-->
<!--            </button>-->
            <button type="button" @click="moveGoodsDetail(goods, 'GIFT')">선물하기
              <div class="gift-badge" v-if="goods.giftConditionKey">
                <span v-if="goods.giftConditionKey == 'FIXED_RATE_EXTRA_CHARGE' || goods.giftConditionKey == 'FIXED_RATE_DISCOUNT'">{{goods.giftConditionValue}}%</span>
                <span v-else-if="goods.giftConditionKey == 'FLAT_EXTRA_CHARGE' || goods.giftConditionKey == 'FLAT_DISCOUNT'">{{goods.giftConditionValue | comma}}원</span>
                <span v-if="goods.giftConditionKey == 'FIXED_RATE_EXTRA_CHARGE' || goods.giftConditionKey == 'FLAT_EXTRA_CHARGE'">추가</span>
                <span v-else-if="goods.giftConditionKey == 'FIXED_RATE_DISCOUNT' || goods.giftConditionKey == 'FLAT_DISCOUNT'" >할인</span>
              </div>
            </button>
          </div>
        </li>
      </ul>
    </div>
</template>

<script>
export default {
    name: 'emarticonAwardList',
    props: {
      goodsList: [],
      totalRows: 0,
    },
    data() {
        return {
          orderCriteria: 'GOODS_AMOUNT_DESC',
          // orderName: '높은 가격순',
          orderConditionList: [
            { "orderCriteria": "GOODS_AMOUNT_DESC", "orderName": "높은 가격순" },
            { "orderCriteria": "GOODS_AMOUNT_ASC", "orderName": "낮은 가격순" },
            { "orderCriteria": "BENEFIT_DESC", "orderName": "혜택 큰 순" }
          ], //상품 정렬조건
        };
    },
    filters: {
      comma(num) {
        return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
    },
    // watch: {
    //   orderCriteria() {
    //     this.orderName = this.orderConditionList.find(x => x.orderCriteria == this.orderCriteria).orderName; //웹접근성 title용
    //   }
    // },
    mounted() {
        
    },

    methods: {
      moveGoodsDetail(goodsInfo, orderType) {
        if(orderType === 'BUY') {
          this.$router.push({name: 'productDetail', query: {goodsInfo:goodsInfo.goodsNo, orderType:orderType, benefitNo:goodsInfo.issueBenefitNo}});
        } else {
          this.$router.push({name: 'productDetail', query: {goodsInfo:goodsInfo.goodsNo, orderType:orderType, benefitNo:goodsInfo.giftBenefitNo}});
        }
      }
    },
};
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/list/emarticonList.scss';
</style>